import { Link } from 'react-router-dom';
import './Stempel.css';
import { ReactNode, memo } from 'react';

interface StempelProps {
  children?: ReactNode;
}

const Stempel: React.FC<StempelProps> = memo(({ children }) => (
  <div id="center">
    <div id="right_column">
      <div className="right_column_front">
        {/* Добавляем фоновое изображение как <img> с lazy */}
        <img
          src="/images/right_column_front.webp"
          alt="Фон правой колонки"
          loading="lazy"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: -1,
          }}
        />
        <div className="right_content">
        <img
            src="/images/portrait.webp"
            alt="Сергей Мавроди"
            loading="lazy"
            width="201"  // Точные размеры
            height="231" // Точные размеры
          />
          <div className="rc_text">
            Мир плох?<br />
            Что ж, сделай его лучше!
          </div>
          <Link to="/contacts" className="contacts-link" aria-label="Перейти на страницу Контакты">КОНТАКТЫ</Link>
        </div>
      </div>
    </div>

    <div id="left_column">
      <div className="left_column">
        <div className="left_column_top">
          <div className="left_column_bot_back">
            <div className="left_column_bot_front"></div>
          </div>
        </div>

        <div className="left_content">
          {children}
        </div>
      </div>
    </div>
  </div>
));

export default Stempel;